import { Business, StarredBusiness, User } from 'model';
import { BaseApi } from './BaseAPI';

const baseURL = 'stars/';
export const StarredBusinessApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		starBusiness: builder.mutation<StarredBusiness, { businessId: Business['_id']; userId: User['_id'] }>({
			query: ({ businessId, userId }) => ({
				url: `${baseURL}handleStar/${userId}/${businessId}`,
				method: 'PUT',
				body: { businessId, userId }
			}),
			invalidatesTags: (...args) => [{ type: 'StarredBusiness', id: args[2].businessId }]
		}),
		getStarredBusiness: builder.query<StarredBusiness, { businessId: Business['_id'] }>({
			query: ({ businessId }) => ({
				url: `${baseURL}${businessId}`,
				method: 'GET'
			}),
			providesTags: (result, error, arg) => [{ type: 'StarredBusiness', id: arg.businessId }]
		})
	})
});

export const { useStarBusinessMutation, useGetStarredBusinessQuery } = StarredBusinessApi;
